// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a8369ef1","453":"b1894f69","778":"81771bdf"}[chunkId] + ".chunk.js";
};